import { render, staticRenderFns } from "./CardVerified.vue?vue&type=template&id=0587936a&scoped=true"
import script from "./CardVerified.vue?vue&type=script&lang=js"
export * from "./CardVerified.vue?vue&type=script&lang=js"
import style0 from "./CardVerified.vue?vue&type=style&index=0&id=0587936a&prod&lang=css"
import style1 from "./CardVerified.vue?vue&type=style&index=1&id=0587936a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587936a",
  null
  
)

export default component.exports